export const sizes = {
  container: {
    xs: '500px',
    lg: '1400px',
    xl: '1500px',
  },
};
